// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"appBadge_r-mobile__GzlHc","r-not-mobile":"appBadge_r-not-mobile__ssue_","button":"appBadge_button__3fYmJ"};